// // import $ from 'jquery';
// import autosize from 'autosize';

// /**
//  * Wrap Tables
//  * @url https://foundation.zurb.com/sites/docs/table.html#scrolling-table
//  */
// // Get all table elements
// const tables = document.querySelectorAll('.main table');

// // create wrapper container
// const wrapper = document.createElement('div');
// wrapper.classList.add('table-scroll');

// // insert wrapper before el in the DOM tree
// tables.forEach((table) => {
//   table.parentNode.insertBefore(wrapper, table);
//   wrapper.appendChild(table);
// });


// /**
//  * Responsive Embeds
//  * @url https://foundation.zurb.com/sites/docs/responsive-embed.html
//  */
// // $('iframe[src*="youtube"]').wrap("<div class='responsive-embed widescreen'/>");
// // $('iframe[src*="vimeo"]').wrap("<div class='responsive-embed widescreen vimeo'/>");
// // $('iframe[src*="dailymotion"]').wrap("<div class='responsive-embed widescreen dailymotion'/>");


// /**
// * Autosize Textarea
// * @url https://www.jacklmoore.com/autosize/
// */
// const textareas = document.querySelectorAll('textarea.js-autosize');
// autosize(textareas);

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b;

const calcWinsize = () => {
  return {width: window.innerWidth, height: window.innerHeight};
};

// Gets the mouse position
const getMousePos = (e) => {
  let posx = 0;
  let posy = 0;
  if (!e) e = window.event;
  if (e.pageX || e.pageY) {
    posx = e.pageX;
    posy = e.pageY;
  }
  else if (e.clientX || e.clientY)    {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }

  return { x : posx, y : posy }
};

const distance = (x1,y1,x2,y2) => {
  var a = x1 - x2;
  var b = y1 - y2;

  return Math.hypot(a,b);
}

// clamp value
const clamp = (value, min, max) => {
  if (min && (value < min)) return min;
  if (max && (value > max)) return max;
  return value;
}

// Generate a random float.
const getRandomFloat = (min, max) => (Math.random() * (max - min) + min).toFixed(2);

// create a jsonp call
const jsonp = (url, callback) => {
  const callbackName = `jsonp_callback_${  Math.round(100000 * Math.random())}`;
  window[callbackName] = function(data) {
    delete window[callbackName];
    document.body.removeChild(script);
    callback(data);
  };

  const script = document.createElement('script');
  script.src = `${url + (url.indexOf('?') >= 0 ? '&' : '?')  }callback=${  callbackName}`;
  document.body.appendChild(script);
}

export {
  map,
  lerp,
  calcWinsize,
  getMousePos,
  distance,
  getRandomFloat,
  clamp,
  jsonp
};
